import { render, staticRenderFns } from "./CardLocation.vue?vue&type=template&id=180bed44&scoped=true&"
import script from "./CardLocation.vue?vue&type=script&lang=js&"
export * from "./CardLocation.vue?vue&type=script&lang=js&"
import style0 from "./CardLocation.vue?vue&type=style&index=0&id=180bed44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180bed44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VBtn,VIcon})
